import { ANGLE_PORTRAIT, ASPECT_RATIO_PORTRAIT, TAN_PORTRAIT } from './const'
import { getAspectRatioPortrait } from './App'
import { MathUtils } from 'three'
import TWEEN from '@tweenjs/tween.js'

const { Cubic } = TWEEN.Easing
const tan = Math.tan(MathUtils.degToRad(ANGLE_PORTRAIT))
const tanNeg = Math.tan(MathUtils.degToRad(180 - ANGLE_PORTRAIT))
const getTanDouble = () => 1 + TAN_PORTRAIT * getAspectRatioPortrait() * 2
const getTanNegDouble = () => -1 - TAN_PORTRAIT * getAspectRatioPortrait() * 2

const SHAPE_KEYFRAMES = {
	inForward: {
		duration: 750,
		delay: 750,
		top: () => [getTanNegDouble(), 0],
		easing: Cubic.Out
	},
	inBackward: {
		duration: 750,
		delay: 750,
		top: () => [getTanNegDouble(), 0],
		easing: Cubic.Out
	},
	outForward: {
		duration: 1000,
		top: () => [0, 0.5],
		easing: Cubic.In
	},
	outBackward: {
		duration: 1000,
		top: () => [0, -0.5],
		easing: Cubic.In
	}
}

export const SHAPES_PORTRAIT = {
	mask: {
		sizing: 'fill',
		align: ['center', 'center'],
		skew: [0, tanNeg],
		baseAspect: ASPECT_RATIO_PORTRAIT,
		keyframes: {
			inForward: {
				duration: 1000,
				top: () => [getTanNegDouble(), 0],
				easing: Cubic.In
			},
			inBackward: {
				duration: 1000,
				top: () => [getTanDouble(), 0],
				easing: Cubic.In
			}
		}
	},
	intro: {
		baseAspect: ASPECT_RATIO_PORTRAIT,
		skew: [0, tanNeg],
		align: ['center', 'center'],
		sizing: 'fill',
		autoResize: [false, true],
		keyframes: {
			inForward: {
				alpha: [0, 0]
			},
			inBackward: {
				duration: 750,
				top: () => [0, getTanNegDouble()],
				easing: Cubic.In
			}
		}
	},
	start1: {
		sizing: 'fill',
		align: ['center', 'center'],
		skew: [0, tan],
		centerSkew: true,
		keyframes: {
			inBackward: {
				duration: 1000,
				top: () => [getTanDouble(), 0],
				easing: Cubic.In
			}
		}
	},
	start2: {
		skew: [0, tanNeg],
		baseAspect: ASPECT_RATIO_PORTRAIT,
		align: ['center', 'center'],
		sizing: 'fill',
		autoResize: [false, true],
		centerSkew: true,
		keyframes: {
			inForward: {
				duration: 1000,
				top: () => [getTanNegDouble(), 0],
				easing: Cubic.Out
			},
			inBackward: {
				duration: 1000,
				delay: 250,
				top: () => [getTanNegDouble(), 0],
				easing: Cubic.Out
			},
			outForward: {
				duration: 750,
				top: () => [0, -1 - TAN_PORTRAIT * getAspectRatioPortrait() * 0.5],
				easing: Cubic.In
			},
			outBackward: {
				duration: 750,
				top: () => [0, 0.1],
				easing: Cubic.In
			}
		}
	},
	left: {
		skew: [0, tan],
		baseAspect: ASPECT_RATIO_PORTRAIT,
		align: ['center', 'center'],
		sizing: 'fill',
		autoResize: [false, true],
		keyframes: SHAPE_KEYFRAMES
	},
	right: {
		skew: [0, tanNeg],
		baseAspect: ASPECT_RATIO_PORTRAIT,
		align: ['center', 'center'],
		sizing: 'fill',
		autoResize: [false, true],
		keyframes: SHAPE_KEYFRAMES
	}
}
